var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBalanceM(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 187,
    viewBox: "0 0 115 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.2568 67.5049C65.264 69.6313 64.7604 71.8696 64.8164 74.1078C64.9283 77.5212 64.7044 80.9906 65.9355 84.348C66.4951 85.9708 66.4391 87.7614 65.0402 89.1604C64.8164 89.3842 64.6485 89.608 64.6485 89.9438C64.3127 92.7416 63.1936 95.4835 63.977 98.3933C64.1449 98.9529 64.033 99.6244 63.977 100.24C63.8651 102.031 63.977 103.709 64.3687 105.5C64.7604 107.346 64.0889 109.193 63.7532 110.984C62.9698 115.181 61.5149 119.209 60.5636 123.35C60.06 125.477 59.3325 127.659 60.2279 129.897C60.2838 130.009 60.1719 130.233 60.2279 130.289C61.7387 131.688 61.1791 133.59 61.5149 135.269C61.6268 135.941 61.6828 137.172 60.3957 137.284",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7439 157.485C51.2745 157.597 47.8612 157.653 44.4478 157.933C43.9441 155.583 43.8882 153.344 45.0633 151.106C45.5109 150.323 45.7907 149.987 46.742 149.875C48.7005 149.595 50.659 150.099 52.6735 149.819C56.8143 149.203 61.0111 149.875 65.152 149.259C65.8234 149.147 66.3271 149.259 66.6628 150.043C67.5581 152.225 68.4534 154.352 68.0617 156.758C67.1664 157.037 66.1592 156.982 65.152 157.037C63.0815 157.093 61.0111 157.149 58.9967 157.149C58.2133 157.149 57.8775 157.373 57.9335 158.213C58.1013 163.584 58.2132 168.956 58.493 174.328C58.6049 176.734 58.605 179.141 58.6609 181.603C58.7169 183.058 58.9967 184.568 58.605 186.135C57.3739 186.471 56.0309 186.303 54.7439 186.023C54.7439 182.274 54.7439 178.581 54.7439 174.832C54.7439 170.187 54.7999 165.543 54.9118 160.843C54.9677 159.388 55.0237 157.989 55.0237 156.534C54.9677 155.527 55.2475 154.967 56.3667 154.911C57.4298 154.855 57.7096 155.079 57.8216 156.534C57.8216 156.702 57.7096 156.926 57.9335 157.093",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.979 129.17C100.853 130.009 98.6145 130.513 96.3762 131.184C91.1722 132.751 85.9122 134.15 80.6522 135.661C74.329 137.452 68.0059 139.242 61.7386 141.033",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4498 141.257C47.3017 139.802 42.1536 138.291 37.0055 136.836C32.3051 135.493 27.6047 134.094 22.9043 132.807C19.2671 131.8 15.6299 130.793 12.0486 129.729",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.028 127.268C97.6073 128.555 93.1866 129.954 88.71 131.129C80.876 133.255 73.1539 135.549 65.3199 137.732C64.3686 138.011 63.4174 138.291 62.522 138.515",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80838 126.596C1.30476 126.54 0.913062 126.708 1.02498 127.268C1.08093 127.883 0.745187 128.499 1.52859 129.058C3.54305 130.625 5.83729 130.625 8.13154 130.177C9.3626 129.954 10.5937 129.954 11.8247 129.562C12.1605 128.89 11.6569 128.051 12.2164 127.435C14.7905 128.499 17.4764 129.114 20.1624 129.842C28.1643 132.136 36.1662 134.43 44.224 136.668C46.798 137.396 49.428 138.123 52.0021 138.795",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5274 94.3643C55.2476 96.9383 54.744 99.5683 55.6393 102.142C56.1429 103.541 55.5833 104.94 55.2476 106.283C54.6321 108.689 54.8559 111.095 55.2476 113.558C56.031 118.09 56.3108 122.679 55.7512 127.267C55.5274 128.834 54.5761 130.289 54.8559 131.968C55.1357 133.646 54.8559 135.269 54.688 136.948C54.6321 137.619 54.744 138.067 55.3595 138.291",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2565 43.2197C32.6969 44.8425 31.4659 46.0735 30.4027 47.3606C29.5633 48.4238 28.9478 49.431 29.0037 50.9978C29.0597 53.0122 28.5001 55.0267 28.0524 57.0412C27.8846 57.8805 27.7727 58.7199 27.7167 59.5593C27.6607 60.7344 27.8846 61.7975 28.9478 62.525C29.899 63.1405 30.1788 64.0918 30.1788 65.2109C30.1788 66.2182 30.5146 67.1694 30.2907 68.1207C28.612 67.9529 29.3954 65.9384 28.1084 65.3788C27.7167 66.2741 27.4369 67.1135 27.0452 67.8969C26.6535 68.6243 26.5976 69.2958 26.9333 70.0792C27.325 70.9745 27.4369 71.8699 26.9333 72.7652C26.0939 72.5973 26.2059 71.646 25.5903 71.2543",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9279 91.8467C32.9766 93.8052 31.6337 95.4839 30.0109 96.9388C28.1084 98.6735 26.7654 100.688 26.0939 103.262C25.3105 106.116 23.0162 108.018 21.1697 110.089C19.7707 111.6 18.092 112.887 17.0288 114.677C16.3014 115.908 15.9097 117.195 16.4692 118.706C17.0288 120.217 16.0775 121.728 14.4548 122.12C13.9512 122.231 13.3916 122.399 12.832 122.455C11.9927 122.567 11.0414 122.735 10.7616 123.91C10.5937 124.638 9.75436 124.806 9.3067 125.421",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5271 88.9922C23.0722 90.7269 22.1209 92.7973 21.2815 94.8677C20.4422 96.8822 19.2671 98.7847 18.092 100.631C16.4692 103.149 15.462 105.947 14.3428 108.689C13.0558 111.935 11.8807 115.236 9.5305 117.978C7.73987 120.048 6.67669 122.623 4.83009 124.693C4.32648 125.253 3.54308 125.253 3.20734 125.868",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.918 129.953C109.918 129.17 109.918 128.442 109.918 127.715C107.68 127.211 105.497 127.099 103.315 126.875C102.476 126.763 101.524 126.763 100.629 126.596C99.8455 126.484 99.5098 127.155 98.8943 127.323C91.6758 129.281 84.4573 131.352 77.2388 133.31C72.6503 134.541 68.0618 135.996 63.4173 137.115C62.9697 137.227 62.6339 137.451 62.1863 137.619",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0143 127.268C17.9241 128.387 21.0017 129.058 24.0234 129.954C29.3953 131.52 34.8232 133.031 40.251 134.542C44.28 135.661 48.3089 136.78 52.3378 137.899",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.43 63.7559C55.7512 64.2035 54.0166 64.6512 52.3378 65.0988C48.6447 66.0501 44.9515 66.3299 41.2023 65.6025C39.1879 65.2108 37.1734 65.6024 35.159 65.2107C33.9279 64.9869 32.6968 64.4833 31.2419 64.7631C31.2419 66.3859 31.6896 67.8967 31.8015 69.4635",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6535 40.1416C25.4224 42.1561 24.3033 44.2265 23.2401 46.3529C22.6246 47.5839 22.8484 49.2626 22.6246 50.7175C22.065 54.4667 22.8484 58.1598 23.4639 61.853C23.6878 63.196 23.6878 64.483 23.5199 65.77C23.1841 67.8964 23.1282 69.9668 23.9675 71.9813",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0329 61.3506C64.5925 62.078 65.152 62.7495 65.5997 63.5329C65.9355 64.0925 66.0474 64.708 66.0474 65.3795C65.9354 66.9463 65.0961 67.5059 63.6412 67.1142C61.9625 66.6665 60.2838 66.6665 58.5491 66.8344C53.7927 67.2821 49.3161 69.0727 44.5598 69.5204C40.8106 69.9121 37.0055 70.024 33.3123 69.4644C32.2491 69.2965 31.8575 69.5204 31.4098 70.4157C29.1715 74.8363 27.5487 79.4807 25.3105 83.8454C24.6949 85.0205 23.9675 86.1956 23.4639 87.5386C25.1426 89.4971 27.5487 90.0007 29.843 90.6722C32.5289 91.4556 35.2709 91.5675 38.0128 91.6235C38.5164 91.6235 38.6283 91.2318 38.8521 90.8401C40.1951 88.0422 41.0344 85.0205 42.6013 82.3905C43.5525 80.8237 44.4479 79.2569 46.0706 78.1937C47.2457 77.4103 47.8612 77.2984 49.0363 78.0818C50.1555 78.8652 51.1627 79.8725 51.9461 80.9356C52.7295 81.9429 52.17 83.2299 52.2259 84.405C52.2259 84.6848 52.17 85.1324 52.0021 85.4682C51.2187 87.3707 51.7782 88.8256 53.7368 89.7769",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6142 153.456C65.264 153.736 62.8578 153.736 60.5076 153.792C57.5419 153.904 54.5761 154.184 51.6664 154.128C49.1483 154.072 46.6862 154.575 44.1681 154.407",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5275 9.75684C57.0384 13.7858 58.0456 17.9266 56.6467 22.2913C59.1088 23.2985 61.2352 24.9213 63.5854 25.9845C67.5583 27.7191 69.9645 30.7408 71.5313 34.7138C72.1468 36.2246 73.0981 37.5676 73.9375 39.0225C74.3851 39.8059 74.553 40.7572 75.1126 41.4846C75.5043 41.9882 75.1126 42.4359 74.8328 42.8276C73.4898 44.8421 71.3634 45.5695 69.1811 46.185C68.9573 46.241 68.7894 46.297 68.6215 46.4648",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0634 22.6828C44.3919 22.2352 44.0562 22.9066 43.6085 23.1305C41.594 23.8579 39.5796 24.5294 37.5651 25.3128C34.2636 26.5998 31.8015 29.006 30.1788 32.1396C28.9477 34.4898 27.7726 36.896 26.0379 38.8545C27.8285 41.0368 30.5704 42.7715 34.7113 43.1072C33.816 39.0223 33.5362 34.8815 33.5362 30.7407",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4536 31.5244C68.0059 34.1544 67.4463 36.7284 66.9427 39.3584C66.1593 43.0516 64.6485 46.521 63.921 50.2142C63.3615 53.1239 62.7459 56.0897 64.2568 58.9435C64.8163 60.0626 63.921 61.1818 62.69 61.1818C61.5708 61.1818 60.4517 61.5735 59.3325 61.0699",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0634 16.249C44.9514 17.7039 45.3431 19.1028 45.6229 20.5577C45.7908 21.3411 45.6789 21.9567 45.3431 22.7401C44.7836 24.083 45.2312 25.7058 45.9587 26.9928C47.1897 29.1192 48.9244 30.5181 51.7223 30.4062C54.5761 30.2383 57.8776 27.3286 58.0455 24.4747C58.0455 24.083 57.9895 23.6354 58.3252 23.2437",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7113 43.3311C35.7185 45.2896 36.39 47.2481 36.2222 49.4864C36.1662 50.7734 35.6626 51.8925 35.159 52.9557C34.4315 54.5785 34.4875 55.9774 35.3828 57.4323C36.2222 58.7753 36.502 60.0623 35.2149 61.3493C34.3196 62.2446 34.6554 63.6436 33.8719 64.5948",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7676 44.8428C66.2712 45.794 66.7189 46.7453 68.0618 46.4655C68.3416 46.4096 68.5095 46.5775 68.6214 46.8572C69.3488 48.7598 70.9716 50.1587 71.8669 51.9494C72.1467 52.5089 72.3146 52.9566 72.3705 53.5721C72.4825 54.6913 72.8742 55.8104 73.4337 56.7617C73.8814 57.601 74.2731 58.3844 74.4969 59.3357",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3813 4.5531C57.2621 3.54587 56.143 2.59459 55.0238 1.58736C54.4643 1.1397 53.8487 1.08375 53.1213 1.02779C50.9389 0.971831 48.8126 0.859916 46.91 2.31481C46.1826 2.87438 45.7909 3.48991 45.2873 4.21735C44.6158 5.22459 44.1681 6.39969 43.3847 7.40692C42.3775 8.63798 42.4894 10.4286 42.7692 12.0514C42.993 13.3944 44.0562 13.898 45.0075 14.8492C45.1194 13.0026 45.0075 11.3799 45.2873 9.75713C45.3992 9.1416 46.2945 8.63798 45.623 7.91054",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M102.699 127.435C102.979 127.715 102.867 128.05 102.811 128.386C102.755 129.114 103.203 129.393 103.763 129.449C105.777 129.561 107.68 130.065 109.694 130.121C111.261 130.177 112.436 129.058 113.667 128.33C113.891 128.218 113.835 127.211 113.667 126.651C113.499 126.036 112.772 126.036 112.324 125.98C109.134 125.588 105.889 125.252 102.643 125.029C101.133 124.917 99.6777 125.42 98.2228 125.7",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8163 88.9928C64.5365 88.6571 64.7043 88.2654 64.7043 87.9296C64.7043 85.9711 64.6484 86.0271 62.8018 85.0758C61.4588 84.4043 60.0039 84.1805 58.605 83.7888C57.2061 83.453 55.919 84.1245 54.5761 84.4603C53.7367 84.6841 53.0093 86.7545 53.401 87.9296C53.9605 89.7202 53.7927 91.5109 54.1844 93.3015C54.3522 94.1968 54.2963 95.2041 55.1356 95.8755",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7584 22.6836C56.031 23.2991 56.1989 24.4183 55.4714 25.1457C54.9678 25.7053 54.4082 26.2649 53.7927 26.3768C51.6104 26.8244 49.3721 27.2721 47.7493 25.0898C47.5814 24.8659 47.4136 24.5861 47.0778 24.5302",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4931 4.83301C58.5491 5.05684 58.4372 5.28067 58.605 5.5045C60.3397 8.30236 60.6755 11.1562 58.9967 14.066",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3828 36.8955C35.5506 39.2457 35.7744 41.6519 35.8864 44.0021C35.9423 44.4497 35.9983 44.8974 35.7745 45.3451",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5812 126.204C14.8465 125.701 13.1678 125.309 11.3212 125.533C10.5937 125.589 9.8663 125.589 9.19481 125.533C8.63524 125.533 7.96374 125.589 7.62799 125.98C6.90055 126.764 6.06119 126.652 5.16588 126.652C4.10269 126.652 4.27056 126.092 4.38248 125.421",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0486 127.435C10.7056 127.043 9.41858 127.546 8.13156 127.714C6.00518 127.994 3.87881 128.162 1.97626 126.875",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4155 140.193C55.3036 143.327 55.1357 146.461 55.0238 149.594",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4299 140.193C57.7097 143.271 57.3739 146.405 57.7097 149.482",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7639 15.6895C49.7639 17.2003 49.8758 18.6552 49.3722 20.166C50.1556 20.3899 50.8271 20.5018 51.4986 20.5018",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4783 65.3789C25.1426 67.897 25.4224 70.471 25.3104 72.9891C24.4151 73.157 24.639 72.3736 24.2473 72.2057",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1555 7.35156C50.827 7.63135 51.1627 8.35879 51.7783 8.69454C53.1772 9.58985 54.6321 9.98156 56.1989 9.25411C56.3668 9.1422 56.6466 9.25411 56.8704 9.25411",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7387 64.5947C59.7802 64.9305 58.1574 65.9377 56.4787 66.889",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4932 14.234C59.7243 14.1221 60.116 14.8495 59.9481 15.8568C59.7243 17.3117 59.0528 18.4308 57.5419 18.9344",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M61.347 140.025C62.0185 142.823 62.0185 142.823 59.2206 142.823C58.7729 142.823 58.3253 142.823 57.8776 142.823",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0001 14.2334C43.2727 14.737 42.9929 17.0313 43.6084 17.7028C44.0001 18.1504 44.3918 18.654 45.0633 18.654",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8544 60.2861C76.8471 59.2229 75.5042 59.8384 74.3291 59.5027C74.1052 59.4467 73.7135 59.6146 73.3778 59.4467C72.9861 59.2788 72.4825 59.055 72.3146 59.7265C72.2027 60.1742 72.3705 60.5099 72.9301 60.7337C73.4897 60.9575 74.1612 61.0695 74.5529 61.629",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9572 35.5537C68.9012 37.4563 68.3416 39.135 66.9427 40.5339",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5811 126.485C15.6858 126.765 14.7905 127.157 13.7832 127.045C13.3915 126.989 12.832 126.821 12.5522 127.437",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6721 66.1621C76.4555 66.9455 76.2316 67.9527 76.0638 68.8481C75.9519 69.3517 75.6721 69.7993 75.9518 70.4149C76.6233 70.5827 77.015 70.0232 77.4067 69.6315",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1841 67.1133C21.6173 68.2884 22.065 69.6873 22.5686 71.1982C22.8484 71.0863 23.0162 70.9743 23.1841 70.8624",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5709 136.836C62.2423 137.675 62.3543 138.683 62.5781 139.746C58.9968 140.138 55.4715 139.746 51.9462 140.138C51.8902 138.627 52.6736 137.563 53.0654 136.332C53.2892 135.605 54.0726 135.997 54.6321 135.941",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1985 95.2041C23.9675 95.4279 22.7364 95.9315 21.4494 95.316",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6755 101.359C59.5564 102.199 58.4372 102.423 57.2062 101.639",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3812 185.855C56.9263 184.512 56.5905 184.456 54.9118 185.295",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4151 65.9385C24.4151 67.1695 24.3592 68.3446 23.7437 69.4078",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0147 8.69434C46.7422 9.03008 47.5256 9.42178 48.309 9.64561C48.7566 9.75752 49.1483 9.9254 49.54 9.47774",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1685 49.9346C73.6576 49.9905 72.9302 51.0537 72.3706 52.2288",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2038 128.219C18.3717 127.659 18.6515 127.1 18.3157 126.484C17.8121 126.428 17.3085 126.372 16.8608 126.372",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4482 65.6585C76.4554 65.7704 77.2948 65.2108 78.5258 65.0989C78.5818 65.7704 78.4699 66.4979 78.8056 67.1694C79.0294 67.617 78.6377 67.9528 78.302 68.2325C77.8543 68.5123 77.1828 70.8625 78.4139 70.9185C80.2605 69.1838 80.7641 66.9455 80.3724 64.5953C80.1486 63.1404 80.2605 61.7975 80.5962 60.3985C81.3237 57.2649 81.2677 54.1313 79.8688 51.2775C78.4699 48.4237 76.8471 45.7377 75.0565 43.0518",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6218 126.484C98.6146 126.149 97.6074 125.981 96.5442 125.925C96.2084 126.484 96.1525 127.044 96.3763 127.659",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3037 13.3947C54.2405 13.3947 53.2332 13.2828 52.226 13.6745",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4696 6.84766C48.0292 8.69425 49.4281 9.64552 51.2187 10.0372C51.7223 10.1491 52.2819 10.1491 52.6736 9.64552",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M112.884 126.485C111.932 126.821 110.981 127.213 110.086 127.549",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7911 62.413C75.2243 61.2938 74.8326 61.3498 73.8254 62.5249C73.2658 63.1964 73.8814 63.7 73.8254 64.3155L74.8886 66.2181C74.7767 66.7217 74.6648 67.2253 74.329 67.6729C73.9933 68.1206 74.2731 68.4563 74.6088 68.7361C75.2803 68.5123 75.3922 67.617 76.0637 67.3932",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4209 13.9546C47.5815 13.5629 46.7422 13.7308 45.8469 13.6748",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9031 65.7705C77.3507 66.5539 77.6865 67.3933 77.8543 68.3445",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5563 136.277C60.2278 136.445 60.2278 136.445 60.0599 137.788C58.9408 138.068 57.8216 138.795 56.5906 138.124",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6861 77.7458C45.9587 76.9624 45.0634 77.466 44.28 77.466",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99069 124.861C2.70368 124.693 2.42389 124.917 2.64772 125.924",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3667 137.62C56.3667 135.997 55.4714 137.004 54.9118 137.06",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4498 140.305C52.7296 141.144 52.5057 141.983 52.6176 142.991C53.3451 142.991 54.0725 142.991 54.8559 142.991",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0581 22.9629C51.3306 22.9629 50.6032 22.9629 49.9317 22.9629",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94206 128.219C4.71823 128.89 4.77419 129.562 4.94206 130.233",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9659 26.4323C46.9659 25.3132 47.0219 24.1381 46.4064 23.1309C46.1825 22.7392 45.9587 22.3475 45.8468 21.8998L45.7349 21.4521",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3325 137.899C59.3325 137.395 59.5004 136.836 58.9408 136.556C58.7729 136.5 58.5491 136.5 58.5491 136.836",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6465 4.38574C57.5978 4.94532 58.605 4.55361 59.6123 4.66553",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9895 137.62C58.1574 136.725 57.6538 136.557 56.9263 136.557",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2134 13.5615C58.2694 14.4568 57.9336 15.2402 57.5419 15.9677",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1989 24.5303C56.3108 24.866 56.4787 25.2577 56.5906 25.5935",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6177 16.024C53.2892 16.2479 54.1285 16.1919 55.1358 15.9121",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4207 15.8569C47.7492 16.0808 47.0218 15.9688 46.2384 15.5771",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceM);
export default __webpack_public_path__ + "static/media/balance-m.9879138ad8467ceaf6e23f0156b845dd.svg";
export { ForwardRef as ReactComponent };